import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cancellationpolicy',
  templateUrl: './cancellationpolicy.component.html',
  styleUrls: ['./cancellationpolicy.component.css']
})
export class CancellationpolicyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
